var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',{attrs:{"dark":""}},[_c('v-main',[_c('v-fade-transition',{attrs:{"duration":"150","mode":"out-in"}},[_c('router-view')],1)],1)],1),_c('div',{staticClass:"print-section",attrs:{"id":"print-section"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }